export enum Phase {
  CenterHead = 0,
  TurnHead = 1,
  ReturnToCenter = 2,
  Complete = 3,
}

export enum TurnDirection {
  Left = 0,
  Right = 1,
}

export class HeadTracker {
  phase: Phase;
  dir: TurnDirection;

  // represents the progress for each phase
  // the range is between 0.0 and 1.0
  // for Phase.CenterHead, it represents amout of time to center head
  // for Phase.TurnHead, it represents the distance head has been turned
  progress: number;

  lastTime: number;
  centerHeadTime: number;

  constructor() {
    this.phase = Phase.CenterHead;
    this.dir = TurnDirection.Left;
    this.progress = 0;
    this.lastTime = 0;

    this.centerHeadTime = 0;
  }

  setTurnDirection(dir: TurnDirection) {
    this.dir = dir;
  }

  start() {
    this.phase = Phase.CenterHead;
    this.lastTime = Date.now();
    this.centerHeadTime = 0;
  }

  update(yrot: number) {
    const now = Date.now();
    const dt = (now - this.lastTime) / 1000;
    this.lastTime = now;

    if (this.phase === Phase.CenterHead) {
      this.centerHeadTime += dt;
      this.progress = this.centerHeadTime / 3.0;
      if (this.centerHeadTime > 3) {
        this.phase = Phase.TurnHead;
        if (window.navigator.vibrate) {
          window.navigator.vibrate(200);
        }
      }
    } else if (this.phase == Phase.TurnHead) {
      if (this.dir === TurnDirection.Right) {
        yrot *= -1;
      }

      this.progress = Math.min(Math.max(yrot, 0), 30) / 30;
      //if (Math.abs(yrot) > 30) {
      if (this.progress >= 1) {
        this.phase = Phase.ReturnToCenter;
        if (window.navigator.vibrate) {
          window.navigator.vibrate(200);
        }
      }
    } else if (this.phase == Phase.ReturnToCenter) {
      if (Math.abs(yrot) < 2) {
        this.phase = Phase.Complete;
        if (window.navigator.vibrate) {
          window.navigator.vibrate(200);
        }
      }
    }
  }

  isComplete() {
    return this.phase === Phase.Complete;
  }
}
